import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ListResponse, PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { AdvancedListRequest } from "types/api/commons";

import { PageBody, PageDetails, PageListItem } from "types/api/page";

function usePageApi() {
    const { get, del, post, put } = useHttpManaged();
    const getAllPage = React.useCallback((queryParams: AdvancedListRequest, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ListResponse<PageListItem>> => {
        return get<undefined, AdvancedListRequest, ListResponse<PageListItem>>({
            url: "/page",
            queryParams: queryParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const getOnePage = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<PageDetails> => {
        return get<PathParamsWithId, undefined, PageDetails>({
            url: "/page/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const createPage = React.useCallback((body: PageBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, PageBody, ResponseWithId>({
            url: "/page",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updatePage = React.useCallback((pathParams: PathParamsWithId, body: PageBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, PageBody, null>({
            url: "/page/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    const deletePage = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/page/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getAllPage,
        getOnePage,
        createPage,
        updatePage,
        deletePage
    };
}

export default usePageApi;